import React, {useEffect, useState} from 'react';
import PageLayout from "../components/page-layout";
import Grid from "@material-ui/core/Grid";
import {useGetAllUsers} from "../services/user";
import UsersTable from "../components/users-table";
import Button from "@material-ui/core/Button";
import ActionCard from "../components/action-card";
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
import AssessmentIcon from '@material-ui/icons/Assessment';
import {makeStyles} from "@material-ui/styles";

export default function Users() {

    const [users, setUsers] = useState([]);

    const getAllUsers = useGetAllUsers();

    async function handleUsers() {
        const allUsers = await getAllUsers();
        setUsers(allUsers)
    }

    useEffect(() => {
        handleUsers();
    }, []);


    const classes = useStyles();

    return (
        <PageLayout pageTitle="مدیریت کاربران">
            <Grid container spacing={3} className={classes.actions}>
                <Grid item xs={12} sm={3}>
                    <ActionCard name="مدیریت نقش‌ها" icon={<EnhancedEncryptionIcon/>}
                                path="/roles"/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ActionCard name="لاگ کاربران" icon={<AssessmentIcon/>}
                                path="/logs"/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ActionCard name="آپلودها" icon={<AssessmentIcon/>}
                                path="/uploads"/>
                </Grid>
            </Grid>
            <Grid container justifyContent="center" spacing={3}>
                <Grid item xs={10} sm={8}>
                    <Button variant="contained" color="primary" href='/users/create-user'>افزودن کاربر</Button>
                </Grid>
                <Grid item xs={10} sm={8}>
                    <UsersTable users={users}/>
                </Grid>
            </Grid>

        </PageLayout>
    );
}


const useStyles = makeStyles(theme => ({

    actions: {
        marginBottom: theme.spacing(10)
    },

}));

